import { Link } from "react-router-dom";
import Footerr from "../components/Footerr/Footerr";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";

function NotFoundPage() {
  usePageMeta({
    title: "Page Not Found | Terces Solutions",
    description: "The page you are looking for does not exist.",
    path: "/404",
    noindex: true,
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 pt-40 pb-24 text-center">
        <p className="text-sm font-bold text-primary uppercase tracking-wider mb-4">
          404 — Page not found
        </p>
        <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6">
          This page doesn't exist.
        </h1>
        <p className="text-gray-600 leading-relaxed mb-10 max-w-xl mx-auto">
          The link may be outdated, or the page may have moved. Here are a few
          places worth heading instead.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="px-8 py-3 rounded-full bg-primary text-white font-semibold"
            style={{ backgroundColor: "#1b7840" }}
          >
            Back to Home
          </Link>
          <Link
            to="/Services"
            className="px-8 py-3 rounded-full border border-gray-300 text-gray-800 font-semibold"
          >
            Explore Services
          </Link>
        </div>
      </main>
      <Footerr />
    </div>
  );
}

export default NotFoundPage;
